import { useLocation } from '@reach/router';
import clsx from 'clsx';
import React, { FunctionComponent, useMemo, useState } from 'react';
import Logo from './logo';
import TransitionLink from './transition-link';

const Header: FunctionComponent = () => {
  const location = useLocation();

  const [hideHeader] = useState(
    location.pathname.match(/\/artists\/.+/) ||
      location.pathname.match(/\/projects\/.+/),
  );

  const colorClass = useMemo(
    () => (location.pathname === '/' ? 'text-white' : 'text-black'),
    [location.pathname],
  );

  return (
    <div
      className={clsx(
        'header fixed top-0 items-start justify-between w-full z-10',
        hideHeader ? 'hidden' : 'flex',
        colorClass,
      )}
    >
      <div className="mt-10 ml-10 xl:mt-20 xl:ml-20">
        <TransitionLink to="/" aria-label="Go to home">
          <Logo />
        </TransitionLink>
      </div>
      <div className="flex mr-20 xl:mr-25">
        <TransitionLink
          activeClassName="underline"
          className="block leading-none text-14 sm:text-16 md:text-18 xl:text-16 2xl:text-1vw tracking-0 xl:leading-32 2xl:leading-normal py-30 xl:py-15 xl:hover:underline"
          to="/artists/"
        >
          <span>ARTISTS</span>
        </TransitionLink>
        <TransitionLink
          activeClassName="underline"
          className="block ml-20 leading-none xl:ml-25 text-14 sm:text-16 md:text-18 xl:text-16 2xl:text-1vw tracking-0 xl:leading-32 2xl:leading-normal py-30 xl:py-15 xl:hover:underline"
          to="/info/"
        >
          <span>INFO</span>
        </TransitionLink>
      </div>
    </div>
  );
};

export default Header;
